// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VaJyv","title":"styles_title__2iUAw"};